import { Button, Tooltip } from "antd";
import "./BaseStyle.css";
import { checkPermissions } from "@comps/commonFunctions";


const BaseButton = ({ modkey, permissionAction, text: buttonText, children, notify, ...props }) => {
  if (modkey && permissionAction && !checkPermissions(modkey, permissionAction)) {
    return null;
  }

  const text = buttonText ? buttonText : children;
  const normalizedText = typeof text === "string" ? text.trim().toLowerCase() : "";
  const buttonProps = normalizedText === "refresh" && props.type === "primary"
    ? { ...props, type: undefined, className: `${props.className || ""} refresh-button`.trim() }
    : props;

  // tooltips look the same everywhere - a per-button `color` is dropped on purpose
  const { color: _ignoredTooltipColor, ...tooltip } = notify || {};

  return (
    <Tooltip { ...tooltip }>
      <Button { ...buttonProps }>
        <span className="klok-btn-label">{ text }</span>
      </Button>
    </Tooltip>
  );
};

BaseButton.displayName = "BaseButton";

export default BaseButton;
